import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export interface StyleProps {
  withSeparators?: boolean;
}

export default makeUiStyles((theme: Theme) => createStyles({

    root: {
      listStyle: 'none',
      paddingLeft: 0,
    },
    itemWrapper: {
      display: 'flex',
      marginBottom: 24,
      paddingBottom: 24,
      borderBottom: ({ withSeparators }: StyleProps) => (withSeparators ? `1px solid ${theme.color.greys[15]}` : 'none'),
      position: 'relative',
      '&:last-of-type': {
        marginBottom: 0,
        paddingBottom: 0,
        borderBottom: 'none',
        '&:after': {
          display: 'none',
        },
      },
      '&:after': {
        content: ({ withSeparators }: StyleProps) => (withSeparators ? 'none' : '""'),
        display: 'block',
        width: 2,
        height: 'calc(100% - 12px)',
        backgroundColor: theme.color.greys[30],
        position: 'absolute',
        top: 36,
        left: 16,
        right: 0,
      },
    },
  }), { name: 'VerticalStepper', index: StylesIndexInjections.UI_MOLECULES });
